import {FC} from 'react';

import LineEnd from './end';
import LineJunction from './junction';

const TreeBranch: FC<{kind: 'end' | 'junction'}> = ({kind}) =>
    kind === 'end' ? <LineEnd /> : <LineJunction />;

export default TreeBranch;
